import React from "react";
import Box from "../../../../../../components/box";
import H2 from "../../../../../../components/h2";
import P from "../../../../../../components/p";
import "./styles.css";

const MarketingPoint = (props) => {
  const { header, children, background, alignTo, image } = props;
  return (
    <div className={`marketing-point-container ${alignTo}`}>
      <img src={image} alt="feature" />
      <div className={`marketing-point ${background}`}>
        <Box>
          <H2>{header}</H2>
          <P>{children}</P>
        </Box>
      </div>
    </div>
  );
};

export default MarketingPoint;



/** WEBPACK FOOTER **
 ** ./src/views/pages/home/sections/marketingPoints/components/marketingPoint/index.js
 **/